// extracted by mini-css-extract-plugin
export var inlineLink = "_48-0";
export var inlineLinkButton = "_48-1";